import React from 'react';
import { ColorSwatchList } from '@sainsburys-tech/bolt'; // Not sure if any products exist with more than 12 colour variants. If so,
// will need new UX designs for it. 867/8434 (a bedding set) has 11 colours.

var MAX_VARIATIONS = 12;

var Colours = function Colours(_ref) {
  var currentPartNumber = _ref.currentPartNumber,
      variants = _ref.variants,
      _ref$colSize = _ref.colSize,
      colSize = _ref$colSize === void 0 ? 12 : _ref$colSize,
      dataTest = _ref['data-test'],
      callback = _ref.callback;
  var currentColour = variants.find(function (colour) {
    return colour.partNumber === currentPartNumber;
  });
  var availableColours = variants.map(function (product) {
    return product.shortValue;
  }).slice(0, MAX_VARIATIONS);

  var getPartNumberFromIndex = function getPartNumberFromIndex(index) {
    return variants[index].partNumber;
  };

  var getIndexFromColour = function getIndexFromColour(colour) {
    return variants.map(function (product) {
      return product.shortValue;
    }).indexOf(colour);
  };

  return /*#__PURE__*/React.createElement("div", {
    "data-test": "".concat(dataTest, "-swatch-container"),
    className: "xs-".concat(colSize, "--none")
  }, /*#__PURE__*/React.createElement("p", {
    "data-test": "".concat(dataTest, "-swatch-currentColour")
  }, "Colour: ", currentColour.value), /*#__PURE__*/React.createElement(ColorSwatchList, {
    size: "medium",
    colors: availableColours,
    selectVariant: function selectVariant(index) {
      return callback(getPartNumberFromIndex(index));
    },
    isFixed: true,
    selected: getIndexFromColour(currentColour.shortValue),
    maxVariations: MAX_VARIATIONS,
    "data-test": dataTest
  }));
};

export default Colours;